import React from 'react';
import Seo from '../../components/Seo';

function AvisoLegal() {
  return (
    <div className="page page--narrow">
      <Seo title="Aviso legal" />
      <h1>Aviso legal</h1>
      <p>
        Pendiente de completar con los datos identificativos reales del titular de Libros para Viajeros (nombre o
        razón social, NIF, domicilio, email de contacto y datos de inscripción registral si procede), conforme a
        la LSSI-CE.
      </p>
    </div>
  );
}

export default AvisoLegal;
